// extracted by mini-css-extract-plugin
module.exports = {"post-card":"Social_post-card___domG","post-card__social":"Social_post-card__social__W60a7","no-pointer":"Social_no-pointer__oC4tG"};